module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-auto-template/src/templates/mobile-nav.html -->\n<div id="mobile-flex-tree" class="flex-column container">\n    <div id="mobile-category-tree"\n        data-nx-view="CategoryTreeNodesView"\n        data-nx-collection="Netx.category.tree"\n        class="item scrollable">\n    </div>\n</div>\n<div id="mobile-page-menu"\n    class="nx-action-context"\n    data-action-context="mobilePageMenu"\n    data-nx-template="menuView-pageNavHeader">\n</div>\n';
}
return __p;
};
